import { H3 } from "~/components/common/Typography";
import { JLPTBadge } from "~/components/videos/jlpt-badge";
import { YouTubeBadge } from "~/components/videos/youtube-badge";
import { type SelectVideo } from "~/server/db/videos/schema";

interface VideoHeaderProps {
  video: SelectVideo;
  children: React.ReactNode;
}

export function VideoHeader({ video, children }: VideoHeaderProps) {
  const { summary, title, sourceId } = video;

  return (
    <div className="mt-2 flex w-full flex-col pl-4 pr-4 pt-0 md:mt-0 md:pt-4">
      <span className="mb-3 flex items-center justify-between">
        <JLPTBadge level={video.jlptLevel} className="text-md" />
        <YouTubeBadge videoId={sourceId} />
      </span>
      <div className="mb-4 space-y-4">
        <H3 className="mb-4" rubyContent={summary}>
          {title}
        </H3>

        <div className="line-clamp-4 text-muted-foreground">{children}</div>
      </div>
    </div>
  );
}
